import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function AlterarSenhaPage() {
  const { user, changePassword, logout } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    if (password.length < 8) return setError('A nova senha deve ter pelo menos 8 caracteres.');
    if (password !== confirmation) return setError('As senhas informadas não são iguais.');
    setLoading(true);
    const result = await changePassword(password);
    if (result) { setError(result); setLoading(false); return; }
    navigate('/', { replace: true });
  };

  return <div className="min-h-screen bg-background-50 flex items-center justify-center p-4">
    <div className="w-full max-w-md bg-white border border-background-200 rounded-2xl p-6 shadow-sm">
      <img src="/brand/zschimmer-mark.png" alt="Zschimmer & Schwarz" className="w-16 h-16 object-contain mx-auto mb-4" />
      <h1 className="font-heading text-2xl font-bold text-foreground-950 text-center">Crie sua senha pessoal</h1>
      <p className="text-sm text-foreground-600 text-center mt-2 mb-6">Olá, {user?.name}. Para continuar, substitua a senha temporária.</p>
      <form onSubmit={submit}>
        {error && <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm">{error}</div>}
        <label className="block text-xs font-semibold text-foreground-700 mb-4">NOVA SENHA<input type="password" autoComplete="new-password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" /></label>
        <label className="block text-xs font-semibold text-foreground-700 mb-5">CONFIRMAR NOVA SENHA<input type="password" autoComplete="new-password" minLength={8} required value={confirmation} onChange={(e) => setConfirmation(e.target.value)} className="mt-1.5 w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400" /></label>
        <button disabled={loading} className="w-full py-2.5 rounded-lg bg-primary-500 text-white font-semibold disabled:opacity-50">{loading ? 'Salvando...' : 'Definir senha e continuar'}</button>
      </form>
      <button type="button" onClick={logout} className="w-full mt-3 py-2 text-sm text-foreground-600">Sair e voltar ao login</button>
    </div>
  </div>;
}
